import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, EnvironmentInjector, OnDestroy, OnInit, runInInjectionContext } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Observable } from 'rxjs';

import { ContactComponent } from './features/contact/contact.component';
import { HomeComponent } from './features/home/home.component';
import { HeaderComponent } from './layout/header/header.component';
import { ProjectsComponent } from './features/projects/projects.component';
import { FooterComponent } from './layout/footer/footer.component';
import { ExperienceComponent } from './features/experience/experience.component';
import { BlogComponent } from './features/blog/blog.component';
import { EducationComponent } from './features/education/education.component';

import { AboutComponent } from './features/about/about.component';
import { SkillsComponent } from './features/skills/skills.component';

import { SeoService } from './shared/services/seo.service';
import { NavigationService } from './shared/services/navigation.service';
import { ActiveSectionService } from './shared/services/active-section.service';
import { ToastComponent } from './shared/components/toast/toast.component';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { afterNextRender } from '@angular/core';

@Component({
  selector: 'app-root',
  imports: [
    CommonModule,
    LoaderComponent,
    ToastComponent,
    RouterModule,
    HeaderComponent,
    HomeComponent,
    AboutComponent,
    ExperienceComponent,
    EducationComponent,
    SkillsComponent,
    ProjectsComponent,
    ContactComponent,
    FooterComponent,
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  private activeSectionService: ActiveSectionService;
  private navigationService: NavigationService;
  private seoService: SeoService;
  private injector: EnvironmentInjector;

  activeSection$!: Observable<string>;
  isLoaderHidden = false;

  private readonly loaderDelayMs = 300;
  private loaderTimerId?: ReturnType<typeof setTimeout>;

  constructor(
    activeSectionService: ActiveSectionService,
    navigationService: NavigationService,
    seoService: SeoService,
    injector: EnvironmentInjector
  ) {
    this.activeSectionService = activeSectionService;
    this.navigationService = navigationService;
    this.seoService = seoService;
    this.injector = injector;
    this.activeSection$ = this.activeSectionService.activeSection$;
  }

  ngOnInit(): void {
    this.seoService.init();
    this.navigationService.init();
  }

  ngAfterViewInit(): void {
    this.loaderTimerId = setTimeout(() => {
      this.isLoaderHidden = true;

      runInInjectionContext(this.injector, () => {
        afterNextRender(() => {
          this.activeSectionService.init();
        });
      });
    }, this.loaderDelayMs);
  }

  ngOnDestroy(): void {
    this.navigationService.destroy();
    this.activeSectionService.destroy();

    if (this.loaderTimerId) {
      clearTimeout(this.loaderTimerId);
    }
  }
}

